import { render, staticRenderFns } from "./ykyCodeIndex.vue?vue&type=template&id=28d6670f&scoped=true"
import script from "./ykyCodeIndex.vue?vue&type=script&lang=js"
export * from "./ykyCodeIndex.vue?vue&type=script&lang=js"
import style0 from "./ykyCodeIndex.vue?vue&type=style&index=0&id=28d6670f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6670f",
  null
  
)

export default component.exports